import {createEntityAdapter} from '@reduxjs/toolkit'
import {ISubSpendingType} from '../../types'

export const subSpendingTypesAdapter = createEntityAdapter<ISubSpendingType>()